module.exports = __webpack_public_path__ + "static/media/create-24px.539b3c38.svg";